import { render, staticRenderFns } from "./BarrageList.vue?vue&type=template&id=a3465dea&scoped=true"
import script from "./BarrageList.vue?vue&type=script&lang=js"
export * from "./BarrageList.vue?vue&type=script&lang=js"
import style0 from "./BarrageList.vue?vue&type=style&index=0&id=a3465dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3465dea",
  null
  
)

export default component.exports